export { default } from './svg/align-full.svg';
